import React from 'react';
import styled from 'styled-components';

import { SxProps } from '@mui/material/styles';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { getBoundedScore, getScoreColor } from 'ff/debrief/utils';

interface Props {
    label?: string;
    score?: number;
    size?: 'sm' | 'lg';
    sx?: SxProps;
    ref?: React.Ref<HTMLDivElement>;
}

function CircularScore(props: React.PropsWithChildren<Props>) {
    const hasScore = typeof props.score === 'number';

    const boundedScore = getBoundedScore(props.score);
    const scoreColor = getScoreColor(props.score);

    const size = props.size === 'lg' ? 48 + 8 : 32;

    return (
        <Stack
            direction="row"
            alignItems="center"
            sx={props.sx}
            p={1}
            ref={props.ref}
        >
            <Box
                height={size}
                width={size}
                borderRadius={16}
                bgcolor="#F0F4F7"
                display="flex"
                alignItems="center"
                justifyContent="center"
                position="relative"
            >
                <CircularProgress
                    variant={hasScore ? 'determinate' : 'indeterminate'}
                    value={boundedScore}
                    sx={{
                        color: hasScore ? scoreColor : 'grey.500',
                        position: 'absolute',
                        '& .MuiCircularProgress-circle': {
                            strokeLinecap: 'round',
                        },
                    }}
                    thickness={4.5}
                    size={size}
                />
                <Score color={scoreColor}>{hasScore ? boundedScore : ''}</Score>
            </Box>
            {props.label && <Label ml={1}>{props.label}</Label>}
        </Stack>
    );
}

export default CircularScore;

const Label = styled(Typography)`
    color: #646468;
    font-size: 12px;
    line-height: 16px;
    font-weight: 700;
`;

const Score = styled(Typography)`
    font-size: 14px;
    font-weight: 700;
`;
